import React from 'react';

import { Modal } from 'antd';
import MarkdownViewer from '@/components/MarkdownViewer';
import { InfoCircleOutlined } from '@ant-design/icons';

import PropTypes from 'prop-types';

import styles from './BotInstructionsModal.module.scss';

const BotInstructionsModal = ({ open, onCancel, botName, detailedInstructions }) => {
  return (
    <Modal
      title={
        <div className={styles.modalHeader}>
          <InfoCircleOutlined className={styles.icon} />
          <span>Детальные инструкции: {botName}</span>
        </div>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
      className={styles.modal}
      destroyOnHidden
    >
      <div className={styles.content}>
        {detailedInstructions ? (
          <MarkdownViewer className={styles.markdown}>{detailedInstructions}</MarkdownViewer>
        ) : (
          <div className={styles.noInstructions}>
            <InfoCircleOutlined className={styles.noInstructionsIcon} />
            <p>Детальные инструкции для этого бота не доступны</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

BotInstructionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  botName: PropTypes.string,
  detailedInstructions: PropTypes.string,
};

BotInstructionsModal.defaultProps = {
  botName: 'Бот',
  detailedInstructions: null,
};

export default BotInstructionsModal;
